export default __webpack_public_path__ + "static/media/about-cl-2.fa4a7f60.jpg";